var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationFee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500244,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5813 15.3786L20.6647 11.2953C20.233 11.1203 19.7547 11.1203 19.3347 11.2953L9.41801 15.3786C8.76467 15.647 8.33301 16.2886 8.33301 17.0003V25.167C8.33301 25.8086 8.85801 26.3336 9.49967 26.3336C10.1413 26.3336 10.6663 25.8086 10.6663 25.167V19.1353L19.3347 22.7053C19.5447 22.7986 19.778 22.8336 19.9997 22.8336C20.2213 22.8336 20.4547 22.787 20.6647 22.7053L30.5813 18.622C31.2347 18.3536 31.6663 17.712 31.6663 17.0003C31.6663 16.2886 31.2347 15.647 30.5813 15.3786ZM19.9997 25.167C19.463 25.167 18.938 25.062 18.448 24.8636L12.9997 22.6236V26.9286C12.9997 27.617 13.4197 28.247 14.0497 28.527L19.2997 30.8136C19.5213 30.907 19.7547 30.9536 19.9997 30.9536C20.2447 30.9536 20.478 30.907 20.6997 30.8136L25.9497 28.527C26.5913 28.247 26.9997 27.6286 26.9997 26.9286V22.6236L21.5513 24.8636C21.0497 25.0736 20.5363 25.167 19.9997 25.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationFee);
export default __webpack_public_path__ + "static/media/education_fee.f905f411f0a13d5cffd9fd5b08f9a2a0.svg";
export { ForwardRef as ReactComponent };